import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const HomeStore = model.views(views);

export interface IHomeStore extends Instance<typeof HomeStore> {}

export default HomeStore;
